export const environment = {
  production: false,
  apiUrl: 'https://preprod.api.eros.my-link.online/api',
  webUrl: 'https://preprod.api.eros.my-link.online',
  planifyApiUrl: 'https://preprod.api.eros.my-link.online/planify',
  abmUrl: 'https://preprod.eros.abmec.fr/',
  nrjUrl: 'https://preprod.eros.nrjdiags.fr/',
}
